<template>
  <div class="default-content">
    <span class="title text">{{ rankDescription }} {{ lessonDescription }}</span>
    <span class="subtitle text">{{ $t('vocabulary.list.instructions.subtitle') }}</span>
    <div class="title-line" />
    <div class="header">
      <span>{{ $t('vocabulary.list.instructions.title') }}</span>
    </div>
    <el-row>
      <img src="@/assets/img/vocabulary_instruction.png" />
    </el-row>
    <el-row v-for="(item, idx) in defaultItems" :key="idx">
      <div class="text">
        <el-col :span="2">{{ `${item.number} .` }}</el-col>
        <el-col :span="22">{{ item.content }}</el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import materialMixin from '@/mixins/material';

export default {
  mixins: [materialMixin],
  computed: {
    ...mapState('material', [
      'rankDescription',
      'lessonDescription',
      'articleTitle',
      'currentRanks',
      'currentLessons',
    ]),

    defaultItems() {
      return [
        { number: 1, content: this.$t('vocabulary.list.instructions.step1') },
        { number: 2, content: this.$t('vocabulary.list.instructions.step2') },
        { number: 3, content: this.$t('vocabulary.list.instructions.step3') },
      ];
    },

    rankDescription() {
      if (!this.currentRanks.lv) {
        return;
      }
      return this.formatRankLabel(this.currentRanks.lv, this.currentRanks.rt);
    },
    lessonDescription() {
      if (!this.currentLessons.ln) {
        return;
      }
      return this.formatLessonLabel(this.currentLessons);
    },
  },
};
</script>

<style scoped src="@/assets/css/pc/vocabulary.css" />
